/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_MinifierInputs */

const en_sidebar_minifier = /** @type {(inputs: Sidebar_MinifierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minifier`)
};

const ko_sidebar_minifier = /** @type {(inputs: Sidebar_MinifierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`압축`)
};

const ja_sidebar_minifier = /** @type {(inputs: Sidebar_MinifierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮`)
};

/**
* | output |
* | --- |
* | "Minifier" |
*
* @param {Sidebar_MinifierInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_minifier = /** @type {((inputs?: Sidebar_MinifierInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_MinifierInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_minifier(inputs)
	if (locale === "ko") return ko_sidebar_minifier(inputs)
	return ja_sidebar_minifier(inputs)
});